module.exports = __webpack_public_path__ + "img/t_phd.2394f33f.svg";